import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WebHookCommonServices } from '../webhook-services/webhook-commom.services';
import { NzTableComponent, NzTableFilterValue, NzTableQueryParams, NzTableSortOrder } from 'ng-zorro-antd/table';
import { Field } from 'src/app/interfaces/field';
import { WebhookField } from '../webhook-interfaces/configuration';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FormServices } from 'src/app/services/form.services';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { NzModalService } from 'ng-zorro-antd/modal';

interface WebhookVariable {
    INTERNALID: number;
    NAME: string;
    DESCRIPTION: string;
    CODECOMPANY: string;
    CODECONTRACT: string;
    'FK_MKTPCONTRACTPREF_MKTPCONTRACT->CONTRACTNAME'?:string;
    'FK_MKTPCONTRACTPREF_MKTPCOMPANIES->NAME'?:string;
    CODEMKTP: string;
    TEXT: string;
}

@Component({
    selector: 'app-webhook-variables',
    templateUrl: './webhook-variables.component.html',
    styleUrl: './webhook-variables.component.scss',
    standalone: false
})
export class WebhookVariablesComponent implements OnInit {


    searchCodecompany: any;
    variables: WebhookVariable[] = [];
    nextId = 1;
    editingVariable: WebhookVariable | null = null;
    newVariable: Partial<WebhookVariable> = {};
    loading: boolean=false;
    total: number=1;
    editMode= false;
    pageSize = 10;
    pageIndex = 1;
    visible:{
        CODECONTRACT:boolean;
        CODEMKTP:boolean;
        CODECOMPANY:boolean;
        NAME:boolean;
        TEXT:boolean;
        DESCRIPTION:boolean;
    } = {
        CODECOMPANY: false,
        CODEMKTP: false,
        CODECONTRACT: false,
        NAME:false,
        TEXT:false,
        DESCRIPTION:false
    }


    @ViewChild('variableTable',{ static: false }) table:NzTableComponent<any>;
    currentFilter: {
        key: string;
        value: NzTableFilterValue
    }[]=[];
    loadingRemoveButton: boolean = false;
    loadingAddButton: boolean = false;

    constructor(
        private fb: FormBuilder, 
        private whServices:WebHookCommonServices,
        private messageService:NzMessageService,
        private fs:FormServices,
        private ls:LanguageServices,
        private modal:NzModalService
    ) {}
    variableForm: FormGroup;
    newRow:FormGroup;
    filterFormGroup:FormGroup;

    nameField:WebhookField = {
        field:'NAME',
        label:'name',
        placeholder:'name',
        type:'text',
        
    };

    descriptionField:WebhookField = {
        field:'DESCRIPTION',
        label:'description',
        placeholder:'description',
        type:'text',
    };

    formulaField:WebhookField = {
        field:'TEXT',
        label:'formula',
        placeholder:'formula',
        type:'text',
        showFormula:true
    }

    formulaField2:WebhookField = {
        field:'TEXT',
        label:'formula',
        placeholder:'formula',
        type:'textarea',
        showFormula:true,
        minRows:16,
        maxRows:16
    }

    codeCompanyField:WebhookField = {
        field:'CODECOMPANY',
        label:'codecompany',
        type:'search',
        
        searchProperties:{
            entityName:'Mktpcompanies',
            fields:{
                keyField:'CODECOMPANY',
                valueField:'NAME'
            }
        },
        showKey:true        
    }

    codecontractField:WebhookField = {
        field:'CODECONTRACT',
        label:'codecontract',
        type:'search',
        
        searchProperties:{
            entityName:'Mktpcontract',
            fields:{
                keyField:'CODECONTRACT',
                valueField:'CONTRACTNAME'
            }
        },
        showKey:true        
    };
    
    codemktpField:WebhookField = {
        field:'CODEMKTP',
        label:'codemktp',
        type:'search',
        
        searchProperties:{
            entityName:'Mktplaces',
            fields:{
                keyField:'CODEMKTP',
                valueField:'NAME'
            }
        },
        showKey:true        
    };

    get INTERNALID(){
        if ( this.newRow == null ){
            return '';
        }
        return this.newRow.get('INTERNALID').value;
    }

    ngOnInit(): void {
        this.loadDataFromServer(this.pageIndex, this.pageSize, null, null, []);

        this.newRow = this.fb.group({
            INTERNALID:[''],
            CODECOMPANY:['',Validators.required],
            CODEMKTP:['',Validators.required],
            CODECONTRACT:['',Validators.required],
            NAME:['',Validators.required],
            TEXT:['',Validators.required],
            DESCRIPTION:['',Validators.required],
            TYPE:['T']
        });

        this.filterFormGroup = this.fb.group({
            CODECOMPANY:[''],
            CODEMKTP:[''],
            CODECONTRACT:[''],
            NAME:[''],
            TEXT:[''],
            DESCRIPTION:['']
        });

        this.variableForm = this.fb.group({
            NAME: ['', Validators.required],
            TEXT: ['', Validators.required],
            CODECOMPANY: ['', Validators.required],
            CODECONTRACT: ['', Validators.required],
            CODEMKTP: ['', Validators.required],
            DESCRIPTION: ['', Validators.required]
        });
    }

    

    insertVariable(): void {

        this.whServices.createVarible(this.newRow).then(data=>{

            const variable: WebhookVariable = {
                INTERNALID: data['INTERNALID'],
                NAME: data['NAME'],
                TEXT: data['TEXT'],
                CODECOMPANY: data['CODECOMPANY'],
                CODECONTRACT: data['CODECONTRACT'],
                CODEMKTP: data['CODEMKTP'],
                DESCRIPTION: data['DESCRIPTION']
            };
            this.variables = [...this.variables,variable];
            this.clearRow();
            this.editMode = false;
            this.loadingAddButton = false;
        }).catch(erro=>{
            this.loadingAddButton = false;
            this.messageService.error(erro);
        });
        
      
        
    }

    editVariable(variable: WebhookVariable): void {
        this.editMode = true;
        this.fs.patchForm(variable,this.newRow);
        
    }

    updateVariable(): void {
        if (!this.editingVariable) return;
        const index = this.variables.findIndex(v => v.INTERNALID === this.editingVariable!.INTERNALID);
        if (index !== -1) {
            this.variables[index] = { ...this.editingVariable };
        }
        this.editingVariable = null;
    }

    deleteVariable(variable: WebhookVariable): void {

        this.modal.confirm({
            nzTitle: this.ls.instant('variable.remove.title'),
            nzContent: this.ls.instant('variable.remove.question'),
            nzOkText: this.ls.instant('confirm'),
            nzOkDanger: true,
            nzCancelText: this.ls.instant('cancel'),
            nzOnOk: () => {
                let condition = `INTERNALID = ${variable.INTERNALID}`;
                this.loadingRemoveButton = true;
                this.whServices.removeVariable(condition).then(d=>{
                    this.variables = this.variables.filter(v => v.INTERNALID !== variable.INTERNALID);
                    this.loadingRemoveButton = false;
                }).catch(erro=>{
                    this.messageService.error(erro);
                    this.loadingRemoveButton = false;
                });
            }
        });
        
    }

    editVariableDoubleClick(event){
        this.editVariable(event);
    }

    cancelEdit(): void {
        this.editingVariable = null;
    }

    
    loadDataFromServer(
        pageIndex: number,
        pageSize: number,
        sortField: string | null,
        sortOrder: string | null,
        filter: Array<{ key: string; value: string[] }>
        ): void {
            this.loading = true;
            this.whServices.findContractPref(((pageIndex-1)*pageSize), pageSize, sortField, sortOrder, filter).then(data => {
                this.loading = false;
                this.total = data['totalLines']; // mock the total data here
                this.variables = data['Mktpcontractpref'] || [];
            }, error => {
                this.loading = false;   

            });
    }

     onQueryParamsChange(params: NzTableQueryParams): void {
        
        let { pageSize, pageIndex, sort, filter } = params;
        
        if ( this.currentFilter.length > 0 ){
            filter = this.currentFilter;
        }

        const currentSort = sort.find(item => item.value !== null);
        const sortField = (currentSort && currentSort.key) || null;
        const sortOrder = (currentSort && currentSort.value) || null;
        this.loadDataFromServer(pageIndex, pageSize, sortField, sortOrder, filter);
        
        if ( sort.length > 0 ){
            this.sortField(sort);
        }
    }
    
    sortField(sort: {key:string,value:NzTableSortOrder}[]) {
       for (var item of sort ){
        if ( item.value != null ){
            
            this.variables.sort((a, b) => {
            if (typeof a[item.key] === 'string' && typeof b[item.key] === 'string') {
                
                    if ( a["NAME"] > b["NAME"] ) {
                        return 1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    if ( a["NAME"] < b["NAME"] ) {
                        return -1 * (item.value == 'ascend' ? 1 : -1);
                    }
                    return 0;


            } else {
                return item.value === 'ascend'
                    ? Number(a[item.key]) - Number(b[item.key])
                    : Number(b[item.key]) - Number(a[item.key]);
            }

            
            });
        }
       }
    }

    search(field: string) {
        let index = this.currentFilter.findIndex(d=>d.key=="this."+field);
        
        if  ( index == -1 ){
            this.currentFilter.push({
            key:"this."+field,
            value:this.filterFormGroup.get(field).value
            })
        }else{
            this.currentFilter.find(d=>d.key=="this."+field).value = this.filterFormGroup.get(field).value;
        }
        
        let param:NzTableQueryParams = { 
            pageSize:this.table.nzPageSize,
            pageIndex: this.table.nzPageIndex,
            sort: [],
            filter: this.currentFilter
        }
        this.table.nzQueryParams.emit(param);
        
        this.visible[field] = false;
        
    }

    reset(field: string) {
        this.filterFormGroup.get(field).setValue('');
        let index = this.currentFilter.findIndex(d=>d.key==field);
        this.currentFilter.splice(index,1);
        this.search(field);
    }

   addRow(){
        
        if ( this.newRow.invalid){
            Object.values(this.newRow.controls).forEach(control => {
                if (control.invalid) {
                    control.markAsDirty();
                    control.updateValueAndValidity({ onlySelf: true });
                }
            });
            return;
        }else{
            this.loadingAddButton = true;
            this.insertVariable();
        }
   }

   clearRow(){
        this.newRow.reset();
   }

}